import { FC, KeyboardEvent, memo, useEffect, useRef } from "react";
import { StyledCloseButton, StyledModal, StyledModalBackdrop, StyledModalBodyScroll } from "./Modal.styled";

import CrossIcon from "@/assets/icons/Cross";
import { Heading } from "#/atoms";
import { ModalProps } from "./Modal.interface";

const Modal: FC<ModalProps> = ({ children, onClose, title, top, width, minWidth, maxHeight }) => {
  const ref = useRef<HTMLDivElement>();
  
    const handleKeyDown = (e : KeyboardEvent<HTMLDivElement>) => {
      switch(e.code) {
        case "Escape":
          onClose();
          break;
      }
    }

    useEffect(() => {
      ref.current?.focus();
    })
 
  return (
    <>
      <StyledModal  onKeyDown={handleKeyDown} maxHeight={maxHeight} minWidth={minWidth} tabIndex={0} top={top} width={width}>
        <StyledCloseButton onClick={onClose}>
          <CrossIcon />
        </StyledCloseButton>
        {title && <Heading scale="h3">{title}</Heading>}
        <StyledModalBodyScroll>
          {children}
        </StyledModalBodyScroll>
      </StyledModal>
      <StyledModalBackdrop onClick={onClose} />
    </>
  );
}

export default memo(Modal);
